import { gql } from "@apollo/client";
import { PROMO_DEDUCTION_MATCH_SUMMARY_FRAGMENT } from "./promoDeductionMatchSummary.fragment";

export const GET_PROMO_DEDUCTION_MATCH_SUMMARY = gql`
  ${PROMO_DEDUCTION_MATCH_SUMMARY_FRAGMENT}
  query PromoDeductionMatchSummary($params: GetPromoDeductionMatchSummaryInput!) {
    promoDeductionMatchSummary(params: $params) {
      ...PromoDeductionMatchSummaryFields
    }
  }
`;
